import api from "./api";

const url = "/admin/system-audit-log";

const systemAuditLogApi = {
    getLogsPaged: (page = 1, limit = 10, searchString = "", userId = "", actionType = "", tableName = "", isSuccess = null, fromDate = "", toDate = "") => {
        let qs = `?PageNumber=${page}&PageSize=${limit}`;
        if (searchString) qs += `&searchString=${encodeURIComponent(searchString)}`;
        if (userId) qs += `&userId=${userId}`;
        if (actionType) qs += `&actionType=${actionType}`;
        if (tableName) qs += `&tableName=${tableName}`;
        if (isSuccess !== null && isSuccess !== "") qs += `&isSuccess=${isSuccess}`;
        if (fromDate) qs += `&fromDate=${fromDate}`;
        if (toDate) qs += `&toDate=${toDate}`;
        return api.get(`${url}/paged${qs}`);
    },
    deleteLogsByFilter: (actionType = "", isSuccess = null, fromDate = "", toDate = "") => {
        let qs = `?`;
        if (actionType) qs += `&actionType=${actionType}`;
        if (isSuccess !== null && isSuccess !== "") qs += `&isSuccess=${isSuccess}`;
        if (fromDate) qs += `&fromDate=${fromDate}`;
        if (toDate) qs += `&toDate=${toDate}`;
        return api.delete(`${url}/delete-by-filter${qs}`);
    },
    deleteLogsByIds: (ids) => {
        return api.delete(`${url}/delete-by-ids`, { data: ids });
    }
};

export default systemAuditLogApi;

